(function () {
    'use strict';

    angular
        .module('followUpModule')
        .directive('followUp', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn', 'attachmentService'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn, attachmentService) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.submit = '&';
        directiveScope.viewList = '&';
        directiveScope.getDownloadAttachmentUrl = '&';
        directiveScope.disableDownloadAttachment = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                function ($rootScope, $scope, $controller) {
                    // Box Template
                    $scope.baseTemplatePath = '/app/shared/followUp/followUp.[Template].tpl.html';
                    $controller('BoxTmplController', { $scope: $scope });

                    $scope.downloadFile = function (id, name) {
                      attachmentService.downloadPhysicalFile(attachmentService.getDownloadUrl(id), name);
                    }
                }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();
